import React from 'react';

import NavBar from '../components/NavBar';
import Introduction from '../components/Introduction';

const Home = () => {
    return (
        <div>
            <NavBar/>
            <Introduction />
        </div>
    )
}


export default Home